class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
    if (isNaN(this.cutoffHour)) this.cutoffHour = 12;

    this.dateEl = this.querySelector('[data-delivery-date]');
    this.countdownEl = this.querySelector('[data-delivery-countdown]');
    this.orderDateEl = this.querySelector('[data-order-date]');
    this.processDateEl = this.querySelector('[data-process-date]');
    this.deliverDateEl = this.querySelector('[data-deliver-date]');

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const now = new Date();
    const cutoffToday = new Date(now);
    cutoffToday.setHours(this.cutoffHour, 0, 0, 0);

    let shipDate = new Date(now);
    let nextCutoff;

    if (now < cutoffToday) {
      nextCutoff = cutoffToday;
      shipDate.setHours(0, 0, 0, 0);
    } else {
      shipDate.setDate(shipDate.getDate() + 1);
      shipDate.setHours(0, 0, 0, 0);
      nextCutoff = new Date(shipDate);
      nextCutoff.setHours(this.cutoffHour, 0, 0, 0);
    }

    const diffMs = nextCutoff - now;
    if (diffMs <= 0) {
      this.tick();
      return;
    }

    let deliveryDate = new Date(shipDate);
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    if (deliveryDate.getDay() === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    const hours = Math.floor(diffMs / 3600000);
    const minutes = Math.floor((diffMs % 3600000) / 60000);
    const seconds = Math.floor((diffMs % 60000) / 1000);

    if (this.countdownEl) {
      this.countdownEl.textContent =
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0');
    }

    if (this.dateEl) {
      this.dateEl.textContent = this.formatRelativeDate(deliveryDate, now);
    }

    if (this.orderDateEl) {
      this.orderDateEl.textContent = this.formatShortDate(now);
    }

    if (this.processDateEl) {
      this.processDateEl.textContent = this.formatShortDate(shipDate);
    }

    if (this.deliverDateEl) {
      this.deliverDateEl.textContent = this.formatShortDate(deliveryDate);
    }
  }

  formatShortDate(date) {
    return date.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
  }

  formatRelativeDate(date, now) {
    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);
    const startOfTarget = new Date(date);
    startOfTarget.setHours(0, 0, 0, 0);
    const diffDays = Math.round((startOfTarget - startOfToday) / 86400000);

    const dateStr = date.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' });

    if (diffDays === 0) return 'hoy, ' + dateStr;
    if (diffDays === 1) return 'mañana, ' + dateStr;

    const weekday = date.toLocaleDateString('es-MX', { weekday: 'long' });
    return 'el ' + weekday + ', ' + dateStr;
  }
}

customElements.define('delivery-estimate', DeliveryEstimate);